'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024 from "./presto.-Edit-Group-Site-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457 from "./presto.-Presto-Router$$anon$57.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$56() {
  this.bkl = null;
  this.bkd = null;
  this.bke = false;
  this.bkm = null;
  this.bkn = false;
  this.bkq = null;
  this.bkj = null;
  this.bkk = false;
  this.bkf = null;
  this.bkg = false;
  this.bkh = null;
  this.bki = false;
  this.bko = false;
  this.bkp = false;
  this.bkl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkq = "EditGroupSitePage";
}
export { $c_Lpresto_PrestoRouter$$anon$56 as $c_Lpresto_PrestoRouter$$anon$56 };
$p = $c_Lpresto_PrestoRouter$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$56;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$56() {
}
export { $h_Lpresto_PrestoRouter$$anon$56 as $h_Lpresto_PrestoRouter$$anon$56 };
$h_Lpresto_PrestoRouter$$anon$56.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bkl;
});
$p.L = (function() {
  if ((!this.bke)) {
    this.bkd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bke = true;
  }
  return this.bkd;
});
$p.O = (function() {
  if ((!this.bkn)) {
    this.bkm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkn = true;
  }
  return this.bkm;
});
$p.E = (function() {
  return this.bkq;
});
$p.t = (function() {
  if ((!this.bkk)) {
    this.bkj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bkk = true;
  }
  return this.bkj;
});
$p.M = (function() {
  if ((!this.bkg)) {
    this.bkf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().me(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bkg = true;
  }
  return this.bkf;
});
$p.Q = (function() {
  if ((!this.bki)) {
    this.bkh = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457.$c_Lpresto_PrestoRouter$$anon$57();
    this.bki = true;
  }
  return this.bkh;
});
$p.w = (function() {
  if ((!this.bkp)) {
    this.bko = false;
    this.bkp = true;
  }
  return this.bko;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee427) => ((p) => \u03b4scrutinee427.cFW(p)))($j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024.$m_Lpresto_EditGroupSitePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$56, "presto.PrestoRouter$$anon$56", ({
  On: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$56 as $d_Lpresto_PrestoRouter$$anon$56 };
//# sourceMappingURL=presto.-Presto-Router$$anon$56.js.map
